// extracted by mini-css-extract-plugin
export var AuthorAvatarContainer = "bf_dq";
export var AuthorBioContainer = "bf_dn";
export var AuthorContainer = "bf_dm";
export var AuthorGradientBackground = "bf_dp";
export var AuthorInfoContainer = "bf_dr";
export var AuthorInfoDetails = "bf_ds";
export var AuthorInfoName = "bf_dt";
export var AuthorInfoSection = "bf_dv";
export var MuiPopperRoot = "bf_bM";
export var MuiTooltipPopper = "bf_bN";